import React from 'react'
import { Button, Checkbox, ClickAwayListener, Divider, Grid, Grow, IconButton, InputAdornment, ListItem, ListItemIcon, ListItemText, MenuItem, MenuList, Paper, Popper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, Typography } from '@material-ui/core'
import { useStyles } from './styles'
import { Description, MoreHorizRounded, Person, RecordVoiceOver, Timeline } from '@material-ui/icons';
import { AiTwotoneDelete, AiTwotoneEdit } from 'react-icons/ai';
import { MdAddBox } from 'react-icons/md';
import { useSelector } from 'react-redux'
// import WebAnalytics from '../../../assets/images/WebAnalytics.png';
// import ReceiptandChange from '../../../assets/images/ReceiptandChange.png';
// import MaleUser from '../../../assets/images/MaleUser.png';
import axiosInstance from '../../environment/axiosInstance';
import ticketServices from './ticketServices'
import Backdrop from '../../components/Modal/Backdrop';
import Modal from '../../components/Modal/Modal';
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
toast.configure()


function TicketsTableBody(props: any) {
    const [permisions, setPermissions] = React.useState<any>([])
    const [userData, setuserData] = React.useState<any>([])
    const [directory, setDirectory] = React.useState<any>(false)

    const { _id, ticket_id, title, channel, customer_name, customer_email, ticket_status, createdAt } = props.data

    const classes = useStyles()
    const anchorRef: any = React.useRef<any>(null);
    const [openOptions, setOpenOptions] = React.useState<any>(false);

    const profileDataStore = useSelector((state: any) => state.profileData)
    const { profileData } = profileDataStore;

    React.useEffect(() => {
        setPermissions(props.data.permissions)
        setDirectory(props.data.directoryEnabled)
        setuserData(props.data)
    }, [props.data])


    const handleClose = (event: any) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        setOpenOptions(false);
    };
    const handleToggle = () => {
        setOpenOptions((prevOpen: any) => !prevOpen);
    };
    function handleListKeyDown(event: any) {
        if (event.key === "Tab") {
            event.preventDefault();
            setOpenOptions(false);
        }
    }

    const onchangeDirectoryEnable = (e: any) => {
        // console.log(e.target.checked)
        setDirectory(e.target.checked)
    }


    return (
        <>
            <TableRow key={props.key}>
                <TableCell className={classes.body}>
                    {ticket_id}
                </TableCell>
                <TableCell className={classes.body}>{title}</TableCell>
                <TableCell className={classes.body}>
                    {customer_name}
                </TableCell>
                <TableCell className={classes.body} >
                    {customer_email}
                </TableCell>
                <TableCell className={classes.body}>
                    {channel}
                </TableCell>
                <TableCell className={classes.body}>
                    {ticket_status}
                </TableCell>
                <TableCell className={classes.body}>
                    {createdAt}
                </TableCell>
            </TableRow>
        </>

    )
}

export default TicketsTableBody